import { Box, Link } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TransitionalCode } from "../../assets/data/Constants";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { TkRouteContext } from "../../context/tkRouteContext";
import { IAPI_PRE010_Request } from "../../type/apiType";
import "./_style.scss";
import { httpAPI_FAC019, httpAPI_PRE010 } from "./api/request";
import {
  explain1,
  explain2,
  explain3,
  headList,
  searchFormList,
  searchFormSchema,
} from "./parts";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import _ from "lodash";
import { changeAmountFormat } from "../../utils/useTools";

/**
 * SCRC060033 掛金情報概要説明 （職員の登録内容の確認）
 * 掛金届提出時に登録されている職員の情報を確認する。
 * @return SCRC060033
 */
const SCRC060033 = () => {
  const navigate = useNavigate();
  let location: 5 | 6 | 7 | 8 = useLocation().state?.check;
  const loaction = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_11;
  const [facilityList, setFacilityList] = useState<any>([]);
  const [stateSearchList, setStateSearchList] = useState<any>();
  const searchList = useRef(_.cloneDeep(searchFormList));
  const [bodyList, setBodyList] = useState<any>([]);
  const [allResults, setAllResults] = useState<any>([]);
  const locationState = useLocation().state;
  const [handleChangeValue, setHandleChangeValue] = useState(
    context?.facilityNo ?? ""
  );
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    locationState?.wantToSetInRouterList ?? []
  );
  const previousScreenIdRef = useRef<any>(null);

  useEffect(() => {
    if (routerState.routerList && routerState.routerList.length > 1) {
      const screenId =
        routerState.routerList[routerState.routerList.length - 2].href;
      previousScreenIdRef.current = screenId
        ? screenId.replace(/\//g, "")
        : null;
    } else {
      previousScreenIdRef.current = null;
    }
  }, [routerState]);

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  useEffect(() => {
    let resArr = searchList.current;
    resArr[0].wantToSetValue = context?.staffNameForSearch;
    setStateSearchList([...resArr]);

    if (!context?.facilityNo) {
      handleInit();
    } else {
      let facilityList = context?.facilityList?.map(
        (item) =>
          ({
            label: `${item.facilityNo}:${item.facilityName}`,
            value: item.facilityNo,
          }!)
      );

      setFacilityList(facilityList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    // プルダウン用有効施設一覧参照API実行
    try {
      const res = await httpAPI_FAC019({
        contractorNo:
          state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo
            : state.authInfo?.contractorNo,
        businessType:
          businessState.common?.businessType! !== ""
            ? businessState.common?.businessType!
            : loaction.state?.setBusinessType,
      });

      if (res.resultCd === "I0000") {
        let facilityList = res.facilityList?.map(
          (item) =>
            ({
              label: `${item.facilityNo}:${item.facilityName}`,
              value: item.facilityNo,
            }!)
        );

        setFacilityList(facilityList);
        setBusinessState({
          ...businessState,
          job_11: {
            ...context,
            facilityList: res.facilityList,
          },
        });
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 施設選択
  const handleGetStaffList = async (e: any, type: "change" | "search") => {
    if (type === "change") {
      setHandleChangeValue(e);
      if (!e) return;
    }

    // 掛金納付対象職員届の提出確認参照APIを呼び出す
    try {
      const param: IAPI_PRE010_Request = {
        contractorNo:
          state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo
            : state.authInfo?.contractorNo,
        facilityNo: type === "change" ? e : handleChangeValue,
        staffNameKanji:
          type === "search"
            ? e
            : handleChangeValue === e
            ? context?.staffNameForSearch
            : "",
        screenId: previousScreenIdRef.current ?? null,
      };
      const res = await httpAPI_PRE010({ ...param });

      if (res.resultCd === "I0000") {
        let bodyList = res.staffInfoList?.map((item) => [
          {
            keyword: item.staffNameKanji,
            children: (
              <>
                <Link onClick={() => onLinkClick(item.staffNo, param)}>
                  {`${
                    TransitionalCode[
                      item.transitionalCode as keyof typeof TransitionalCode
                    ] ?? ""
                  }${item.staffNo ?? ""}:${item.staffNameKanji ?? ""}`}
                </Link>
                <br />
                {item.birthday}
                <br />
                {item.sex}
              </>
            ),
          },
          {
            children: (
              <>
                {item.firstJoinDate}
                <br />
                {item.joinCapacity}
                <br />
                {item.jobCd}
              </>
            ),
          },
          {
            children:
              item.enrollPeriod || item.validPeriod ? (
                <>
                  {item.enrollPeriod ? item.enrollPeriod : null}
                  <br />
                  {item.validPeriod ? item.validPeriod : null}
                </>
              ) : null,
          },
          {
            align: "right",
            children: (
              <>
                {item.salaryTableAmt !== null
                  ? changeAmountFormat(item.salaryTableAmt ?? 0)
                  : ""}
                <br />
                {item.salaryAdjustmentAmt !== null
                  ? changeAmountFormat(item.salaryAdjustmentAmt ?? 0)
                  : ""}
              </>
            ),
          },
          {
            children: [
              item.apr === "1" && "4月",
              item.may === "1" && "5月",
              item.jun === "1" && "6月",
              item.jul === "1" && "7月",
              item.aug === "1" && "8月",
              item.sep === "1" && "9月",
              item.oct === "1" && "10月",
              item.nov === "1" && "11月",
              item.dec === "1" && "12月",
              item.jan === "1" && "1月",
              item.feb === "1" && "2月",
              item.mar === "1" && "3月",
            ]
              .filter((i) => i)
              .join("、"),
          },
          {
            children: !!item.childcareLeaveInfoList?.length && (
              <>
                {item?.childcareLeaveInfoList.map((item, index) => {
                  return (
                    <Box key={index}>
                      {`出生日：${item?.birthday}`}
                      <br />
                      {`期間：${item?.getStartDate}-${item?.getEndDate}`}
                    </Box>
                  );
                })}
              </>
            ),
          },
          {
            align: "center",
            children: item.otherMaFlg === "1" && "〇",
          },
        ]);

        setBodyList(bodyList);
        type === "change" && setAllResults(bodyList);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 氏名リンク押下時のイベント
  const onLinkClick = (staffNo: any, search: any) => {
    setBusinessState({
      ...businessState,
      job_11: {
        ...context,
        facilityNo: search.facilityNo,
        staffNameForSearch: search.staffNameKanji,
      },
    });

    navigate("/SCRC080105", { state: { staffNo: staffNo } });
  };

  // 職員検索
  const handleSearchName = async (event: any, index: any) => {
    switch (index) {
      case 0:
        handleGetStaffList(event.name, "search");
        break;
      case 1:
        setBodyList(allResults);
    }
  };

  return (
    <Box data-testid="SCRC060033test" className="SCRC060033">
      {explain1[location]}
      <Box className="info">{explain2[location]}</Box>

      <TkFakeTableLine
        title="施設選択"
        type="selectForm"
        selectPropsList={facilityList}
        onChange={(e: any) => handleGetStaffList(e.target.value, "change")}
        setDefaultValue={facilityList?.length ? context?.facilityNo : ""}
      />

      {handleChangeValue && (
        <>
          <Box className="staffSearch">
            <TkSearchForm
              listData={stateSearchList}
              ruleSchema={searchFormSchema}
              onSearch={(event, index) => handleSearchName(event, index)}
              submitButtonGroup={[
                { submitButtonText: "検索" },
                { submitButtonText: "全件表示" },
              ]}
            />
          </Box>
          <Box className="staffListTable">
            <TkTable headList={headList} bodyList={bodyList} showUnit pagin />
          </Box>
        </>
      )}

      {explain3}

      <Box className="buttonGroup">
        <TkBackButton useBackParam />
      </Box>
    </Box>
  );
};

export default SCRC060033;
